import React from 'react';

const HalfStarIcon = React.memo(() => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1C10.4468 1.00022 9.93552 1.30822 9.65772 1.80858L7.34194 6.64841L2.28611 7.41495C1.72076 7.49967 1.25059 7.91314 1.07372 8.48114C0.896845 9.04914 1.04402 9.67291 1.45323 10.0896L5.14332 13.891L4.28616 19.1686C4.18952 19.7563 4.42041 20.3504 4.88169 20.701C5.34297 21.0515 5.95455 21.0975 6.45907 20.8197L11 18.3404V1Z"
      fill="#FFC60D"
    />
    <path
      d="M11 18.3456L11.032 18.3281L15.5564 20.8197C16.061 21.0976 16.6725 21.0515 17.1338 20.7009C17.5951 20.3503 17.826 19.756 17.7293 19.1681L16.8865 13.8246L20.548 10.0879C20.956 9.67368 21.1029 9.05253 20.9266 8.48707C20.7533 7.91608 20.2822 7.49986 19.7151 7.41687L14.605 6.60975L12.3435 1.80882C12.0656 1.30813 11.5534 1 11 1C10.9998 1 11.0002 1 11 1V18.3456Z"
      fill="#D9DADE"
    />
  </svg>
));

export default HalfStarIcon;
